import Breadcrumb from "@/components/feature/Breadcrumb";
import FeedbackForm from "./components/FeedbackForm";

const services = [
  {
    icon: "ri-film-line",
    title: "影视目录浏览",
    desc: "按电影、电视剧分类浏览作品，查看封面、年份、地区与题材等基础信息。",
  },
  {
    icon: "ri-filter-3-line",
    title: "多维筛选排序",
    desc: "支持按地区、年份、类型筛选，并可切换最新、热门、评分等排序方式。",
  },
  {
    icon: "ri-search-line",
    title: "关键词搜索",
    desc: "输入作品名、类型或地区关键词，快速匹配标题与剧情简介内容。",
  },
  {
    icon: "ri-heart-3-line",
    title: "本地收藏夹",
    desc: "收藏喜欢的作品，数据保存在浏览器本地，下次访问仍可找回。",
  },
];

const steps = [
  { no: "01", title: "选择频道", desc: "从首页或导航进入电影 / 电视剧频道。" },
  { no: "02", title: "筛选与排序", desc: "利用筛选与排序快速缩小范围，找到心仪作品。" },
  { no: "03", title: "查看详情", desc: "点击卡片查看剧情简介、主创信息与相关推荐。" },
  { no: "04", title: "收藏记录", desc: "点击收藏按钮，把喜欢的作品加入本地收藏夹。" },
];

export default function About() {
  return (
    <div className="mx-auto w-full max-w-7xl px-4 py-6 md:px-8 md:py-8">
      <Breadcrumb items={[{ label: "首页", to: "/" }, { label: "关于我们" }]} />

      <div className="mt-4 rounded-lg bg-secondary-900 px-6 py-10 md:px-12 md:py-14">
        <span className="inline-flex items-center gap-1 rounded-full bg-primary-500/90 px-3 py-1 text-xs font-medium text-background-50">
          <i className="ri-movie-2-line" aria-hidden="true"></i>
          日本在线观看
        </span>
        <h1 className="mt-4 max-w-3xl font-heading text-2xl font-bold text-background-50 md:text-4xl">
          专注日本影视浏览与追剧体验的内容平台
        </h1>
        <p className="mt-4 max-w-2xl text-sm leading-relaxed text-background-200/90 md:text-base">
          「日本在线观看」为喜爱日本电影与电视剧的观众打造，聚焦最新、热门的日本影视资源，提供清晰的目录、完善的筛选与便捷的收藏功能，帮助你更轻松地发现与记录喜欢的作品。
        </p>
      </div>

      <section className="mt-10 grid grid-cols-1 gap-6 lg:grid-cols-[1.4fr_1fr]">
        <div className="rounded-lg border border-background-200 bg-background-50 p-6 md:p-8">
          <h2 className="flex items-center gap-2 font-heading text-xl font-bold text-foreground-950">
            <span className="flex h-7 w-7 items-center justify-center rounded-md bg-primary-100 text-primary-600">
              <i className="ri-compass-3-line text-lg" aria-hidden="true"></i>
            </span>
            网站定位
          </h2>
          <p className="mt-4 text-sm leading-7 text-foreground-600">
            我们面向广泛的日本影视爱好者，尤其是追剧爱好者与电影影迷。网站以现代门户的形式组织内容，兼顾专业感与亲和力，让用户在浏览丰富资源的同时，也能快速定位到感兴趣的作品。
          </p>
          <p className="mt-4 text-sm leading-7 text-foreground-600">
            需要说明的是，本站为内容导览性质的演示平台，<strong className="font-semibold text-foreground-800">仅展示影视简介与封面信息</strong>，不提供真实在线播放、下载或支付功能，站内所有作品信息均为虚构示范数据。
          </p>
        </div>

        <div className="rounded-lg border border-background-200 bg-background-50 p-6 md:p-8">
          <h2 className="flex items-center gap-2 font-heading text-xl font-bold text-foreground-950">
            <span className="flex h-7 w-7 items-center justify-center rounded-md bg-accent-100 text-accent-700">
              <i className="ri-contacts-line text-lg" aria-hidden="true"></i>
            </span>
            联系我们
          </h2>
          <ul className="mt-4 space-y-3 text-sm">
            <li className="flex items-center gap-3">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-background-100 text-primary-600">
                <i className="ri-mail-line" aria-hidden="true"></i>
              </span>
              <span className="text-foreground-700">support@jpwatch-demo.com</span>
            </li>
            <li className="flex items-center gap-3">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-background-100 text-primary-600">
                <i className="ri-wechat-line" aria-hidden="true"></i>
              </span>
              <span className="text-foreground-700">微信公众号：日本在线观看</span>
            </li>
            <li className="flex items-center gap-3">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-background-100 text-primary-600">
                <i className="ri-time-line" aria-hidden="true"></i>
              </span>
              <span className="text-foreground-700">工作日 09:00 - 18:00 回复</span>
            </li>
          </ul>
        </div>
      </section>

      <section className="mt-10">
        <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">
          服务内容
        </h2>
        <div className="mt-5 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {services.map((item) => (
            <div
              key={item.title}
              className="rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-200"
            >
              <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-primary-100 text-primary-600">
                <i className={`${item.icon} text-xl`} aria-hidden="true"></i>
              </span>
              <h3 className="mt-3 font-heading text-base font-bold text-foreground-900">
                {item.title}
              </h3>
              <p className="mt-1.5 text-sm leading-relaxed text-foreground-500">
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </section>

      <section className="mt-10">
        <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">
          使用指南
        </h2>
        <div className="mt-5 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {steps.map((step) => (
            <div
              key={step.no}
              className="rounded-lg border border-background-200 bg-background-50 p-5"
            >
              <span className="font-heading text-2xl font-bold text-accent-500">
                {step.no}
              </span>
              <h3 className="mt-2 font-heading text-base font-bold text-foreground-900">
                {step.title}
              </h3>
              <p className="mt-1.5 text-sm leading-relaxed text-foreground-500">
                {step.desc}
              </p>
            </div>
          ))}
        </div>
      </section>

      <section className="mt-10 mb-4 grid grid-cols-1 gap-8 rounded-lg border border-background-200 bg-background-50 p-6 lg:grid-cols-[1fr_1.2fr] md:p-10">
        <div>
          <h2 className="flex items-center gap-2 font-heading text-xl font-bold text-foreground-950 md:text-2xl">
            <span className="flex h-7 w-7 items-center justify-center rounded-md bg-primary-100 text-primary-600">
              <i className="ri-feedback-line text-lg" aria-hidden="true"></i>
            </span>
            意见反馈
          </h2>
          <p className="mt-4 text-sm leading-7 text-foreground-600">
            如果你有内容建议、功能想法或合作意向，欢迎通过右侧表单联系我们。我们会认真阅读每一条反馈，并尽量在工作日内回复。
          </p>
          <p className="mt-4 rounded-md bg-background-100 p-4 text-xs leading-relaxed text-foreground-500">
            提示：请勿在此提交真实播放、下载等文件类需求，本站不支持相关内容。
          </p>
        </div>
        <div>
          <FeedbackForm />
        </div>
      </section>
    </div>
  );
}